export default "__VITE_ASSET__BSJHt4iC__"